


































































































































import Vue from "vue";
import {Component, Prop} from 'vue-property-decorator'

import {CashoutData} from "../models";
import {formatCurrency, ZERO} from "../util/number";
import {doOrder} from "../order";
import {cashoutEventBus, CashoutEvents} from "../bus";

import SkuImage from "./SkuImage";

@Component({
    components: {
        SkuImage,
    }
})
export default class CashoutCheckout extends Vue {
    @Prop()
    cashoutData!: CashoutData;

    get formattedFiatAmount(): string {
        return formatCurrency(this.cashoutData.fiatAmount, this.cashoutData.fiatCurrencyCode)
    }

    get formattedBonusAmount(): string {
        if (!this.cashoutData.bonusAmountDisplay)
            return formatCurrency(ZERO, this.cashoutData.fiatCurrencyCode);
        return formatCurrency(this.cashoutData.bonusAmountDisplay, this.cashoutData.fiatCurrencyCode)
    }

    get formattedCashoutValueGross(): string {
        if (!this.cashoutData.cashoutValueGross)
            return formatCurrency(ZERO, this.cashoutData.fiatCurrencyCode);
        return formatCurrency(this.cashoutData.cashoutValueGross, this.cashoutData.fiatCurrencyCode)
    }

    get formattedTransactionFee(): string {
        if (!this.cashoutData.transactionFee)
            return formatCurrency(ZERO, this.cashoutData.fiatCurrencyCode);
        return formatCurrency(this.cashoutData.transactionFee, this.cashoutData.fiatCurrencyCode)
    }

    get formattedCashoutValueNett(): string {
        if (!this.cashoutData.cashoutValueNett)
            return formatCurrency(ZERO, this.cashoutData.fiatCurrencyCode);
        return formatCurrency(this.cashoutData.cashoutValueNett, this.cashoutData.fiatCurrencyCode)
    }

    get bonusPercentage(): number {
        if (!this.cashoutData.sku) return 0;
        return this.cashoutData.sku.percentDiscount.toNearest(0.01).toNumber()
    }

    get formattedCryptoAmount(): string {
        if (!this.cashoutData.cryptoAmount)
            return formatCurrency(ZERO, this.cashoutData.cryptoCurrencyCode);
        return formatCurrency(this.cashoutData.cryptoAmount, this.cashoutData.cryptoCurrencyCode)
    }

    get formattedFeeSavingAmount(): string {
        if (!this.cashoutData.feeSavingAmount)
            return formatCurrency(ZERO, this.cashoutData.fiatCurrencyCode);
        return formatCurrency(this.cashoutData.feeSavingAmount, this.cashoutData.fiatCurrencyCode)
    }

    get buyButtonEnabled(): boolean {
        let errors = this.cashoutData.purchaseRequestValid;
        return errors.length <= 0;
    }

    changeWalletForm(): void {
        cashoutEventBus.$emit(CashoutEvents.WALLET_FORM_ADJUST);
    }

    purchase(): void {
        let errors = this.cashoutData.purchaseRequestValid;

        // Protect against double-tap
        if (this.cashoutData.orderInProgress) return;

        if (errors.length > 0) {
            console.error(errors);
            alert(errors);
            return;
        }

        doOrder(this.cashoutData)
    }

}
